"use client";

import { useEffect } from "react";
import { useRouter } from "next/navigation";

/**
 * Redirects logged-in visitors away from the public homepage to /dashboard.
 * Runs client-side via a session-status fetch instead of a server-side
 * `await auth()` — that call previously forced `/` into dynamic SSR with
 * `cache-control: private, no-store`, so every visit (crawler or human) was
 * a guaranteed Vercel origin cache-MISS. See KB "Vercel Fast Data Transfer
 * spike" entry. /dashboard itself still enforces its own server-side auth
 * guard, so this is a UX redirect only, not a security boundary.
 */
export function AuthRedirect() {
  const router = useRouter();

  useEffect(() => {
    let cancelled = false;
    fetch("/api/user/session-status")
      .then((res) => res.json())
      .then((data) => {
        if (!cancelled && data.authenticated) {
          router.replace("/dashboard");
        }
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, [router]);

  return null;
}
